import Vue from 'vue'
import Router from 'vue-router'
import Formal from '@/components/Formal'
import News from '@/components/News/index'
import NewsList from '@/components/News/List'
import Home from '@/components/Home'
import NewsXq from '@/components/News/NewsXq'
import Introduction from '@/components/Introduction'
import Contact from '@/components/Contact'
import Department from '@/components/department/index'
import DepartmentList from '@/components/department/List'
import DepartmentXq from '@/components/department/departmentXq'

import Encyclopedia from '@/components/Encyclopedia/index'
import EncyclopediaList from '@/components/Encyclopedia/List'
import EncyclopediaXq from '@/components/Encyclopedia/EncyclopediaXq'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Formal',
      component: Formal,
      redirect:'/Home',
      children:[
        {
          path: '/News',
          name: 'News',
          component: News,
          redirect:'/News/NewsList/1',
          children:[
            {
              path: '/News/NewsList/:type',
              name: 'NewsList',
              component: NewsList
            },
            {
              path: '/News/NewsXq/:id',
              name: 'NewsXq',
              component: NewsXq
            }
          ]
        },
        {
          path: '/Encyclopedia',
          name: 'Encyclopedia',
          component: Encyclopedia,
          redirect:'/Encyclopedia/EncyclopediaList/1',
          children:[
            {
              path: '/Encyclopedia/EncyclopediaList/:type',
              name: 'EncyclopediaList',
              component: EncyclopediaList
            },
            {
              path: '/Encyclopedia/EncyclopediaXq/:id',
              name: 'EncyclopediaXq',
              component: EncyclopediaXq
            }
          ]
        },
        {
          path: '/Home',
          name: 'Home',
          component: Home
        },
        {
          path: '/Introduction/:type',
          name: 'Introduction',
          component: Introduction
        },
        {
          path: '/Contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/Department',
          name: 'Department',
          component: Department,
          redirect:'/Department/DepartmentList/1',
          children:[{
            path: '/Department/DepartmentList/:type',
            name: 'DepartmentList',
            component: DepartmentList,
          },
          {
            path: '/Department/DepartmentXq/:id',
            name: 'DepartmentXq',
            component: DepartmentXq,
          }]
        }
      ]
    },
    {path:'*',redirect:'/Home'}
  ]
})
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js